<style lang="less">
.order{
	.item{
		width: 100%;
		height: 62px;
		box-sizing: border-box;
		padding: 0 12px;
		.vue-item{
			height: 62px;
		}
		.vue-item-submark__subject{
			color: #dd2f2f;
		}
	}
	.faild{
		.vue-item-submark__subject{
			color: #999;
		}
	}
}
</style>

<template>
	<!-- Main order -->
	<section class="order" v-show="iniloading == false">
		<div class="empty_list" v-if="list.length === 0 && !loading">
			<img src="../assets/empty_order_list.png">
			<h3>暂无账单</h3>
		</div>
		<template  v-else>
			<template v-for="item in list">
				<div class="item" :class="item.order_status == 8 || item.order_status == 128 || item.bal_offset_type != 4 ? 'faild' : ''" v-bind:key="item.order_id+'c'" @click="toDetail(item.order_id)">
					<item
					:mark-subject="item.subject"
					:mark-subject-attach="item.day"
					:submark-subject="item.bal_offset_type == 4 ? '+' + item.pay_amt.Format() : '-' + item.pay_amt.Format()"
					:submark-subject-attach="item.order_status == 8 || item.order_status == 128 ? item.order_status_remark : ''"
					ico-type="next"
					></item>
				</div>
			</template>
		</template>
	</section>
</template>

<script>
	import android from '@flyme/jr/js/android.js';
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				loading: false,
				iniloading: true,
				listparams: {
					after_order_id: '',
					order_type: 0,
					size: 10
				},
				list: [],
				type_list: {}
			};
		},
		components: {
			item
		},
		created: function () {
			if (this.$route.query.order_statuses) {
				this.listparams.order_statuses = this.$route.query.order_statuses.split('-');
			}
			android('startLoading', {mes: '正在加载'});
			this.getTypeList();
		},
		mounted: function () {
		},
		beforeDestroy: function () {
			this.removMenu();
		},
		methods: {
			addMenu: function (key, text) {
				let _this = this;
				android('addMenuItem', {
					key: key,
					text: text,
					enable: true
				}, function () {
					_this.clickMenu(key);
				});
			},
			clickMenu: function (key) {
				android('startLoading', {mes: '正在加载'});
				this.listparams.order_type = key;
				this.listparams.after_order_id = '';
				this.list = [];
				this.getList();
				this.loading = true;
			},
			initMenu: function () {
				for( var i in this.type_list) {
					this.addMenu(i, this.type_list[i]);
				}
			},
			removMenu: function () {
				android('removeAllMenuItem');
			},
			getTypeList: function () {
				let _this = this;
				_this.loading = true;

				axios.post(apis.order_type, {}).then(function(d) {
					console.log('order_type', d);
					var t_data = d.value.order_type_infos;
					for( var i in t_data) {
						_this.type_list[t_data[i].value] = t_data[i].desc;
					}
					// _this.getList(0);
					_this.initMenu();
					_this.loading = false;
					_this.watchScroll();
				});
			},
			getList: function () {
				let _this = this;
				if (_this.loading) {
					return;
				}
				console.log(_this.listparams, 'lispaaa');
				axios.post(apis.order_list, _this.listparams).then(function(d) {
					console.log('order_list', d);
					_this.iniloading = false;
					_this.loading = false;
					android('stopLoading', '');
					if (!d.value.order_list_infos.length) {
						return;
					}
					for( var i in d.value.order_list_infos){
						d.value.order_list_infos[i].day = new Date(d.value.order_list_infos[i].create_time).Format("yyyy-MM-dd hh:mm");
					}

					if (_this.list.length > 0) {
						_this.list = _this.list.concat(d.value.order_list_infos);
					}else{
						_this.list = d.value.order_list_infos;
					}
					_this.listparams.after_order_id = _this.list[_this.list.length-1].order_id;
					setTimeout(function () {
						_this.watchScroll();
					}, 500);
				});
			},
			toDetail: function (id) {
				android('startPageWithCallback', {
					url: config.staticURL + '/#/order/detail?id=' + id,
					start_type:1,
					data:'',
					display:{
						title:'账单详情'
					}
				}, function () {
					// _this.getDetail();
				});

				// this.$router.push({ path: '/order/detail', query: { id: id, types:  this.type_list}});
			},

			isScrollToPageBottom: function () {
				var documentHeight = document.documentElement.offsetHeight;
				var viewPortHeight = window.innerHeight;
				var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

				return documentHeight - viewPortHeight - scrollHeight < 20;
			},
			watchScroll: function (){
				let _this = this;
				console.debug(this.isScrollToPageBottom());
				if(!this.isScrollToPageBottom()){
					setTimeout( _this.watchScroll, 900);
					return;
				}
				console.error('watchScroll', 'list length:'+this.list.length);
				if (!this.loading) {
					this.getList();
				}
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Order.vue